<form class="kontakt-form" [formGroup]="form">
  <div class="w-full um-naglowek-a">
    {{'codes.kontakt.kontakt' | translate}}
  </div>
  <div class="w-full mt-8">
    <div class="mb-8">
      <input placeholder="{{'codes.kontakt.email' | translate}}" (keyup)="usunWiodacaSpacje($event)" aria-label="E-mail"
        [tabindex]="0" formControlName="email" value="" class="um-input w-full mb-2">
      <div class="blad-walidacji" *ngIf="form.controls['email'].errors?.['required'] && !form.untouched"
        aria-roledescription="komunikat" [tabindex]="0" role="walidacja">
        E-mail
      </div>
      <div class="blad-walidacji" *ngIf="form.controls['email'].errors?.['email'] && !form.untouched"
        aria-roledescription="komunikat" [tabindex]="0" role="walidacja">
        Pole jest wymagane, podaj poprawny adres e-mail.
      </div>
    </div>
    <div>
      <textarea placeholder="{{'codes.kontakt.tresc-wiadomosci' | translate}}" aria-label="Treść wiadomości"
        formControlName="wiadomosc" maxlength="4000" [tabindex]="0" (keyup)="usunWiodacaSpacje($event)"
        (input)="zmianaWiadomosci($event)" style="height: 302px" class="w-full um-textarea"></textarea>
      <div class="blad-walidacji" *ngIf="form.controls['wiadomosc'].errors?.['required'] && !form.untouched"
        aria-roledescription="komunikat" [tabindex]="0" role="walidacja">
        Pole jest wymagane
      </div>
    </div>
    <div class="licznik text-right mb-2">{{'codes.kontakt.liczba-znakow' | translate}}<span class="liczba-znakow">
        {{wiadomoscLiczbaZnakow}}</span> <span>/4000</span>
    </div>

  </div>
  <div class="przyciski">

    <mm-przycisk-prostokatny class="przycisk" label="{{'codes.generyczne.wyslij' | translate}}" (click)="addWiadomosc()"
      aria-roledescription="komunikat" [tabindex]="0"
      [disabled]="form.status==='INVALID' || czyNiepoprawnyFormat"></mm-przycisk-prostokatny>
  </div>
</form>